import { permissionManager } from "../PermissionManager/PermissionManager";

export const SIDEBAR_VIEW_BOOKMARK = 'sidebar-bookmark';
export const SIDEBAR_VIEW_COMMENT_LIST = 'sidebar-comment-list';
export const SIDEBAR_VIEW_THUMBNAILS = 'sidebar-thumbnail';
export const SIDEBAR_VIEW_LAYERS = 'sidebar-page-manager';
export const SIDEBAR_VIEW_SEARCH = 'sidebar-search';
export const SIDEBAR_VIEW_ATTACHMENT = 'sidebar-attachment';
export const SIDEBAR_VIEW_SIGNATURE = 'sidebar-signature';
export const SIDEBAR_VIEW_FIELD = 'sidebar-field';
export const SIDEBAR_VIEW_DESTINATIONS = 'sidebar-destinations';
export const SIDEBAR_VIEW_ARTICLE = 'sidebar-article';

////////////Sidebar Bookmark
export const SIDEBAR_BOOKMARK_DELETE    = 'toolbar-delete';
export const SIDEBAR_BOOKMARK_ADD       = 'toolbar-save';
export const SIDEBAR_BOOKMARK_FIND      = 'toolbar-find';
export const SIDEBAR_BOOKMARK_ENLARGE   = 'toolbar-enlarge';
export const SIDEBAR_BOOKMARK_SHRINK    = 'toolbar-shrink';
//Sidebar Bookmark ContextMenu
export const SIDEBAR_BOOKMARK_CM_ADD            = 'fv--contextmenu-item-add';
export const SIDEBAR_BOOKMARK_CM_STRUCTURE      = 'fv--contextmenu-item-structure';
export const SIDEBAR_BOOKMARK_CM_EXPAND         = 'fv--contextmenu-item-expand';
export const SIDEBAR_BOOKMARK_CM_GOTO           = 'fv--contextmenu-item-goTo';
export const SIDEBAR_BOOKMARK_CM_PRINTPAGE      = 'fv--contextmenu-item-print-page';
export const SIDEBAR_BOOKMARK_CM_PRINTSECTION   = 'fv--contextmenu-item-print-section';
export const SIDEBAR_BOOKMARK_CM_CUT            = 'fv--contextmenu-item-cut';
export const SIDEBAR_BOOKMARK_CM_PASTEUNDER     = 'fv--contextmenu-item-pasteUnder';
export const SIDEBAR_BOOKMARK_CM_PASTEAFTER     = 'fv--contextmenu-item-pasteAfter';
export const SIDEBAR_BOOKMARK_CM_DELETE         = 'fv--contextmenu-item-delete';
export const SIDEBAR_BOOKMARK_CM_DESTINATION    = 'fv--contextmenu-item-destination';
export const SIDEBAR_BOOKMARK_CM_RENAME         = 'fv--contextmenu-item-rename';
export const SIDEBAR_BOOKMARK_CM_APPEARANCE     = 'fv--contextmenu-item-appearance';
export const SIDEBAR_BOOKMARK_CM_WRAP           = 'fv--contextmenu-item-wrap';
export const SIDEBAR_BOOKMARK_CM_EXPANDCOLLAPSE = 'fv--contextmenu-item-expand-collapse';
export const SIDEBAR_BOOKMARK_CM_HIDE           = 'fv--contextmenu-item-hide';
export const SIDEBAR_BOOKMARK_CM_PROPERTIES     = 'fv--contextmenu-item-properties';
export const SIDEBAR_BOOKMARK_CM_TOC            = 'fv--contextmenu-item-toc';

//Sidebar Commnet
export const SIDEBAR_COMMENT_EXPEND_LIST = 'commentlist-expend-annot-list';
export const SIDEBAR_COMMENT_PREV = 'commentlist-prev-comment';
export const SIDEBAR_COMMENT_NEXT = 'commentlist-next-comment';
export const SIDEBAR_COMMENT_SORT_BY_PAGE = 'sort-comments-by-page';
export const SIDEBAR_COMMENT_SORT_BY_TYPE = 'sort-comments-by-type';
export const SIDEBAR_COMMENT_SORT_BY_AUTHOR = 'sort-comments-by-author';
export const SIDEBAR_COMMENT_SORT_BY_DATE = 'sort-comments-by-date';
export const SIDEBAR_COMMENT_SORT_BY_STATUS = 'sort-comments-by-status';
export const SIDEBAR_COMMENT_SORT_BY_CHECKMARK = 'sort-comments-by-checkmark';
export const SIDEBAR_SEARCH_COMMENT = 'fv--search-comment-component';
export const SIDEBAR_IMPORT_COMMENT = 'commentlist-import-comment';
export const SIDEBAR_EXPORT_COMMENT_XPDF = 'fv--export-xfdf-button';
export const SIDEBAR_EXPORT_COMMENT_FPF = 'fv--export-fdf-button';
export const SIDEBAR_EXPORT_COMMENT_JSON = 'fv--export-json-button';
export const SIDEBAR_EXPAND_ALL_COMMENTS = 'commentlist-expand-commentlist';
export const SIDEBAR_COLLAPSE_ALL_COMMENTS = 'commentlist-collapse-commentlist';

export const SIDEBAR_SHOW_ALL_COMMENTS = 'commentlist-show-comments';
export const SIDEBAR_HIDE_ALL_COMMENTS = 'commentlist-hide-comments';
export const SIDEBAR_COPY_COMMENT_TEXT             = 'copy-comment-text-menu';
export const SIDEBAR_EDIT_COMMENT                  = 'edit-comment-menu';
export const SIDEBAR_DELETE_COMMENT                = 'delete-comment-menu';
export const SIDEBAR_COMMENTLIST_REPLY_MENU_COPY   = 'commentlist-reply-menu-copy';
export const SIDEBAR_COMMENTLIST_REPLY_MENU_EDIT   = 'commentlist-reply-menu-edit';
export const SIDEBAR_COMMENTLIST_REPLY_MENU_DELETE = 'commentlist-reply-menu-delete';
//set_status_none  set_status_accepted  set_status_rejected set_status_cancelled set_status_completed
export const SIDEBAR_SET_STATUS_NONE = 'set_status_none';
export const SIDEBAR_SET_STATUS_ACCEPTED = 'set_status_accepted';
export const SIDEBAR_SET_STATUS_REJECTED = 'set_status_rejected';
export const SIDEBAR_SET_STATUS_CANCELLED = 'set_status_cancelled';
export const SIDEBAR_SET_STATUS_COMPLETED = 'set_status_completed';
export const SIDEBAR_SET_STATUS_DEFERRED = 'set_status_deferred';
export const SIDEBAR_SET_STATUS_FUTURE = 'set_status_future';
export const SIDEBAR_ADD_REPLY = 'sidebar_add_reply';
export const SIDEBAR_PUBLISH_REPLY = 'sidebar_publish_reply';

//Sidebar Attachment
export const SIDEBAR_ATTACHMENT_SAVE = 'attachment-save-button';
export const SIDEBAR_ATTACHMENT_ADD = 'attachment-add-button';
export const SIDEBAR_ATTACHMENT_EDIT = 'attachment-edit-button';
export const SIDEBAR_ATTACHMENT_DELETE = 'attachment-delete-button';

//Sidebar Destinations
export const SIDEBAR_DESTINATIONS_ADD = 'add-destination';
export const SIDEBAR_DESTINATIONS_DELETE = 'delete-destination';


//Sidebar Field
export const SIDEBAR_Field_ORDER_ROW = 'field-order-row';
export const SIDEBAR_Field_ORDER_COLUMN = 'field-order-column';
export const SIDEBAR_Field_ORDER_STRUCTURE = 'field-order-structure';
export const SIDEBAR_Field_ORDER_NUMBERS = 'field-order-numbers';
export const SIDEBAR_Field_ORDERAZ_ALPHABETIC = 'field-orderaz-alphabetic';
export const SIDEBAR_Field_ORDERAZ_TAB = 'field-orderaz-tab';

export const SIDEBAR_CREATE_DATE = 'fv--contextmenu-item-create-date'
export const SIDEBAR_CREATE_IMAGE = 'fv--contextmenu-item-create-image'
export const SIDEBAR_CREATE_SIGN = 'fv--contextmenu-item-create-sign'
export const SIDEBAR_CREATE_TEXT = 'fv--contextmenu-item-create-text'
export const SIDEBAR_CREATE_LIST_BOX = 'fv--contextmenu-item-create-list-box'
export const SIDEBAR_CREATE_COMBO_BOX = 'fv--contextmenu-item-create-combo-box'
export const SIDEBAR_CREATE_RADIO_BUTTON = 'fv--contextmenu-item-create-radio-button'
export const SIDEBAR_CREATE_CHECK_BOX = 'fv--contextmenu-item-create-check-box'
export const SIDEBAR_ADD_NEW_FIELD = 'fv--contextmenu-item-create-push-button'
export const SIDEBAR_DUPLICATE_FIELDS = 'fv--contextmenu-item-duplicate'
export const SIDEBAR_CREATE_MULTIPLE_COPIES = 'fv--contextmenu-item-multiple'
export const SIDEBAR_MENU_SHOW_TAB_NUMBERS = 'fv--contextmenu-item-numbers'
export const SIDEBAR_SHOW_TAB_NUMBERS = 'fv--option-group-item-numbers'
export const SIDEBAR_APPLY_PRINT_OVERRIDES = 'fv--contextmenu-item-apply-print'
export const SIDEBAR_APPLY_EXPORT_OVERRIDES = 'fv--contextmenu-item-apply-export'
export const SIDEBAR_APPLY_LAYER_OVERRIDES = 'fv--contextmenu-item-apply-layer'
export const SIDEBAR_LAYER_PROPERTIES = 'fv--contextmenu-item-properties-layer'
export const SIDEBAR_COLLAPSE_ALL_LAYERS = 'fv--contextmenu-item-collapse';
export const SIDEBAR_EXPAND_ALL_LAYERS = 'fv--contextmenu-item-expand-all-layers'
export const SIDEBAR_RESET_TO_INITIAL_VISIBILITY = 'fv--contextmenu-item-reset';
export const SIDEBAR_LIST_LAYERS_FOR_VISIBLE_PAGES = 'fv--contextmenu-item-visible';
export const SIDEBAR_LIST_LAYERS_FOR_ALL_PAGES = 'fv--contextmenu-item-all';
export const SIDEBAR_PAGE_PROPERTIES = "contextmenu-item-thumbnail-properties"
export const SIDEBAR_ROTATE_PAGE_LEFT = 'contextmenu-item-thumbnail-rotate-left';
export const SIDEBAR_REVERSE_PAGES = 'organize-tab-page-reverse'
export const SIDEBAR_ROTATE_PAGE_RIGHT = 'contextmenu-item-thumbnail-rotate-right';
export const SIDEBAR_DELETE_PAGE = 'contextmenu-item-thumbnail-delete';
export const SIDEBAR_MOVE_PAGE = 'contextmenu-item-thumbnail-move';
export const SIDEBAR_SPLIT_DOC = 'contextmenu-item-thumbnail-split';
export const SIDEBAR_CROP_PAGE = 'contextmenu-item-thumbnail-crop';
export const SIDEBAR_DUPLICATE_PAGE = 'contextmenu-item-thumbnail-duplicate';
export const SIDEBAR_ROTATE_PAGE = 'contextmenu-item-thumbnail-rotate';
export const SIDEBAR_EXTRACT_PAGE = 'contextmenu-item-thumbnail-extract';
export const SIDEBAR_REPLACE_PAGE = 'contextmenu-item-thumbnail-replace';
export const SIDEBAR_THUMBNAIL_COPY = 'contextmenu-item-thumbnail-copy';
export const SIDEBAR_THUMBNAIL_PASTE = 'contextmenu-item-thumbnail-paste';
export const SIDEBAR_THUMBNAIL_EMBED = 'contextmenu-item-thumbnail-embed';
export const SIDEBAR_THUMBNAIL_REMOVE_EMBEDDED = 'contextmenu-item-thumbnail-remove-embedded';
export const SIDEBAR_THUMBNAIL_SWAP = 'contextmenu-item-thumbnail-swap';
export const SIDEBAR_THUMBNAIL_FORMAT_PAGE_NUMBERS = 'contextmenu-item-thumbnail-format-numbering';
export const SIDEBAR_THUMBNAIL_PAGE_TRANSITIONS = 'contextmenu-item-thumbnail-pageTransitions';


export const SIDEBAR_LAYER_DELETE= 'fv--contextmenu-item-delete';
export const SIDEBAR_LAYER_MERGE = 'fv--contextmenu-item-merge';
export const SIDEBAR_LAYER_IMPORT = 'fv--contextmenu-item-import';
export const SIDEBAR_LAYER_FLATTEN = 'fv--contextmenu-item-flatten';
export const SIDEBAR_LAYER_DELETE2 = 'fv--contextmenu-item-delete-layer';
export const SIDEBAR_LAYER_SHOW = 'fv--contextmenu-item-show-layer';

// Sidebar Article
export const SIDEBAR_ARTICLE_HIDE_AFTER_USE = 'fv--article-contextmenu-hide';
export const SIDEBAR_ARTICLE_READ = 'fv--article-contextmenu-read';
export const SIDEBAR_ARTICLE_DELETE = 'fv--article-contextmenu-delete';
export const SIDEBAR_ARTICLE_RENAME = 'fv--article-contextmenu-rename';
export const SIDEBAR_ARTICLE_PROPERTIES = 'fv--article-contextmenu-properties';

export const SIDEBAR_SET_WHOLE_WORD = 'sidebar_set_whole_word';
export const SIDEBAR_SET_CASE_SENSITIVE = 'sidebar_set_case_sensitive';
export const SIDEBAR_SEARCH_TEXT = 'sidebar_search_text'
// TODO
export const SIDEBAR_ADJUST_SIDEBAR_WIDTH = 'xxx';
export const SIDEBAR_COLLAPSE_SIDEBAR = 'xxx';
export const SIDEBAR_EXPAND_SIDEBAR = 'xxx';


// Insert from file, Insert into file, Extract, Move, Split
export const SIDEBAR_COMMENT_CARD_LIST = [
    SIDEBAR_COPY_COMMENT_TEXT,
    SIDEBAR_EDIT_COMMENT,
    SIDEBAR_DELETE_COMMENT,
    SIDEBAR_COMMENTLIST_REPLY_MENU_COPY,
    SIDEBAR_COMMENTLIST_REPLY_MENU_EDIT,
    SIDEBAR_COMMENTLIST_REPLY_MENU_DELETE
];
export const SIDEBAR_COMMENT_LIST = [
    SIDEBAR_EXPAND_ALL_COMMENTS,
    SIDEBAR_COLLAPSE_ALL_COMMENTS,
    SIDEBAR_IMPORT_COMMENT,
    SIDEBAR_EXPORT_COMMENT_XPDF,
    SIDEBAR_EXPORT_COMMENT_FPF,
    SIDEBAR_EXPORT_COMMENT_JSON,
]


export const SIDEBAR_LIST = [
    //...SIDEBAR_COMMENT_LIST,
    SIDEBAR_REVERSE_PAGES,
    SIDEBAR_DELETE_PAGE,
    SIDEBAR_MOVE_PAGE,
    SIDEBAR_SPLIT_DOC,
    SIDEBAR_CROP_PAGE,
    SIDEBAR_DUPLICATE_PAGE,
    SIDEBAR_LAYER_DELETE,
    SIDEBAR_LAYER_MERGE,
    SIDEBAR_LAYER_IMPORT,
    SIDEBAR_LAYER_FLATTEN,
    SIDEBAR_LAYER_DELETE2,
    SIDEBAR_LAYER_SHOW,
    SIDEBAR_ROTATE_PAGE,
    SIDEBAR_EXTRACT_PAGE,
    SIDEBAR_THUMBNAIL_COPY,
    SIDEBAR_THUMBNAIL_PASTE,
    SIDEBAR_THUMBNAIL_SWAP,
    SIDEBAR_THUMBNAIL_FORMAT_PAGE_NUMBERS,
    SIDEBAR_THUMBNAIL_PAGE_TRANSITIONS,
    SIDEBAR_ROTATE_PAGE_LEFT,
    SIDEBAR_ROTATE_PAGE_RIGHT,
    SIDEBAR_REPLACE_PAGE,
    SIDEBAR_THUMBNAIL_EMBED,
    SIDEBAR_THUMBNAIL_REMOVE_EMBEDDED,
    SIDEBAR_PAGE_PROPERTIES,
    SIDEBAR_LIST_LAYERS_FOR_ALL_PAGES,
    SIDEBAR_LIST_LAYERS_FOR_VISIBLE_PAGES,
    SIDEBAR_RESET_TO_INITIAL_VISIBILITY,
    SIDEBAR_COLLAPSE_ALL_LAYERS,
    SIDEBAR_LAYER_PROPERTIES,
    SIDEBAR_APPLY_LAYER_OVERRIDES,
    SIDEBAR_APPLY_EXPORT_OVERRIDES,
    SIDEBAR_APPLY_PRINT_OVERRIDES,
    SIDEBAR_SHOW_TAB_NUMBERS,
    SIDEBAR_MENU_SHOW_TAB_NUMBERS,
    SIDEBAR_CREATE_MULTIPLE_COPIES,
    SIDEBAR_DUPLICATE_FIELDS,
    SIDEBAR_ADD_NEW_FIELD,
    SIDEBAR_CREATE_CHECK_BOX,
    SIDEBAR_CREATE_RADIO_BUTTON,
    SIDEBAR_CREATE_COMBO_BOX,
    SIDEBAR_CREATE_LIST_BOX,
    SIDEBAR_CREATE_TEXT,
    SIDEBAR_CREATE_SIGN,
    SIDEBAR_CREATE_IMAGE,
    SIDEBAR_CREATE_DATE,
];
// premium features
export const SIDEBAR_PREMIUM_BTNS = [
    SIDEBAR_DELETE_PAGE,
    SIDEBAR_EXTRACT_PAGE,
    SIDEBAR_THUMBNAIL_COPY,
    SIDEBAR_THUMBNAIL_PASTE,
    SIDEBAR_THUMBNAIL_SWAP,
    SIDEBAR_THUMBNAIL_FORMAT_PAGE_NUMBERS,
    SIDEBAR_THUMBNAIL_PAGE_TRANSITIONS,
    SIDEBAR_ROTATE_PAGE_LEFT,
    SIDEBAR_ROTATE_PAGE_RIGHT,
    SIDEBAR_MOVE_PAGE,
    SIDEBAR_SPLIT_DOC,
    SIDEBAR_CROP_PAGE,
    SIDEBAR_DUPLICATE_PAGE,
    SIDEBAR_LAYER_DELETE,
    SIDEBAR_LAYER_MERGE,
    SIDEBAR_LAYER_IMPORT,
    SIDEBAR_LAYER_FLATTEN,
    SIDEBAR_LAYER_DELETE2,
    SIDEBAR_LAYER_SHOW,
    SIDEBAR_ROTATE_PAGE,
    SIDEBAR_REPLACE_PAGE,
    SIDEBAR_THUMBNAIL_EMBED,
    SIDEBAR_THUMBNAIL_REMOVE_EMBEDDED,
    SIDEBAR_BOOKMARK_CM_ADD,
    SIDEBAR_BOOKMARK_CM_STRUCTURE,
    SIDEBAR_BOOKMARK_CM_EXPAND,
    SIDEBAR_BOOKMARK_CM_GOTO,
    SIDEBAR_BOOKMARK_CM_PRINTPAGE,
    SIDEBAR_BOOKMARK_CM_PRINTSECTION,
    SIDEBAR_BOOKMARK_CM_CUT,
    SIDEBAR_BOOKMARK_CM_PASTEUNDER,
    SIDEBAR_BOOKMARK_CM_PASTEAFTER,
    SIDEBAR_BOOKMARK_CM_DELETE,
    SIDEBAR_BOOKMARK_CM_DESTINATION,
    SIDEBAR_BOOKMARK_CM_RENAME,
    SIDEBAR_BOOKMARK_CM_APPEARANCE,
    SIDEBAR_BOOKMARK_CM_WRAP,
    SIDEBAR_BOOKMARK_CM_EXPANDCOLLAPSE,
    SIDEBAR_BOOKMARK_CM_HIDE,
    SIDEBAR_BOOKMARK_CM_PROPERTIES,
    SIDEBAR_BOOKMARK_CM_TOC,
];
permissionManager.registerPremiumFeatures(SIDEBAR_PREMIUM_BTNS);
permissionManager.registerCNJPPremiumFeatures(SIDEBAR_PREMIUM_BTNS);